/* @flow */

import {
    STATUS_PENDENTE,
    STATUS_PAGO,
    STATUS_CANCELADO,
    STATUS_EXPIRADO,
    STATUS_DEVOLVIDA,
    STATUS_AUTORIZADA,
    STATUS_EM_DISPUTA,
    STATUS_PARCIALMENTE_PAGA,
    STATUS_CHARGEBACK,
} from './constants';

const traduzirEtapasIugu = (status: String) => {
    switch (status) {
    case STATUS_PENDENTE: return 'Pendente';
    case STATUS_PAGO: return 'Pago';
    case STATUS_CANCELADO: return 'Cancelado';
    case STATUS_EXPIRADO: return 'Expirado';
    case STATUS_DEVOLVIDA: return 'Devolvida';
    case STATUS_AUTORIZADA: return 'Autorizada';
    case STATUS_EM_DISPUTA: return 'Em disputa';
    case STATUS_PARCIALMENTE_PAGA: return 'Parcialmente Paga';
    case STATUS_CHARGEBACK: return 'Chargeback';
    default: return 'Status desconhecido';
    }
};

export default traduzirEtapasIugu;
